import { useRouter } from "next/router";
import type { Locales } from "~/i18n/i18n-types";
import { ar, es, ca, pt, ru, mt, enUS, et } from "date-fns/locale"; // Import the French locale

const useDateFnsLocale = () => {
	const { locale: nextLocale } = useRouter();
	const locale = (nextLocale ?? "en") as Locales;

	switch (locale) {
		case "ar":
			return ar;
		case "es":
			return es;
		case "ca":
			return ca;
		case "pt":
			return pt;
		case "ee":
			return et;
		case "ru":
			return ru;
		case "mt":
			return mt;
		case "tl":
			return enUS;
		default:
			return enUS;
	}
};

export default useDateFnsLocale;
